export default node => {
    const regex = /(auto|scroll)/
    const parents = (_node, ps) => {
        if (_node.parentNode === null) {
            return ps
        }
        return parents(_node.parentNode, ps.concat([_node]))
    }

    const style = (_node, prop) =>
        getComputedStyle(_node, null).getPropertyValue(prop)

    const overflow = _node =>
        style(_node, 'overflow') +
        style(_node, 'overflow-y') +
        style(_node, 'overflow-x')

    const scroll = _node => regex.test(overflow(_node))

    const scrollParent = _node => {
        if (!(_node instanceof HTMLElement || _node instanceof SVGElement)) {
            return
        }
        const ps = parents(_node.parentNode, [])
        for (const psItem of ps) {
            if (scroll(psItem)) {
                return psItem
            }
        }

        return document.scrollingElement || document.documentElement
    }

    return scrollParent(node)
}
